import script from "./AddTypesAndKinds.vue?vue&type=script&setup=true&lang=js"
export * from "./AddTypesAndKinds.vue?vue&type=script&setup=true&lang=js"

import "./AddTypesAndKinds.vue?vue&type=style&index=0&id=5ae34500&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ae34500"]])

export default __exports__